// Footer.js — synced with SixthSens footer layout + responsive form
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const SITE = "https://sixthsens.ai";

const Footer = () => {
  return (
    <footer id="footer">
      <div
        className="container-fluid footer-top"
        style={{ backgroundColor: "#37517e", color: "white" }}
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12 p-5">
            {/* margin overridden by home-light CSS on small screens */}
            <div className="row footer-services" style={{ marginLeft: "3rem" }}>
              <h2 style={{ marginBottom: "2rem" }}>Our Services</h2>
              <div className="col-lg-12 col-md-12 footer-links">
                <ul>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href={`${SITE}/solutions/vision_ai.html`}>Vision AI</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href={`${SITE}/solutions/voice_ai.html`}>Voice AI</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href={`${SITE}/solutions/text_ai.html`}>Text AI</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href={`${SITE}/solutions/generative_ai.html`}>
                      Generative AI
                    </a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href={`${SITE}/solutions/automation.html`}>Automation</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href={`${SITE}/solutions/data_intelligence.html`}>
                      Data Intelligence
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 p-5">
            <div
              className="d-flex flex-column footer-contact-form"
              style={{ boxSizing: "border-box", width: "80%" }}
            >
              <h2>Contact Us</h2>
              <form
                id="fs-frm"
                name="simple-contact-form"
                acceptCharset="utf-8"
                action="https://formspree.io/f/moqobbry"
                method="post"
              >
                <div style={{ marginLeft: "12px" }}>
                  {/* Stacked full-width fields — same as SixthSens mobile-friendly form */}
                  <div className="row mb-3 d-flex justify-content-between">
                    <input
                      className="col-12 border rounded-3 p-2 mt-3"
                      type="text"
                      name="name"
                      id="full-name"
                      placeholder="Name"
                      required
                    />
                    <input
                      className="col-12 border rounded-3 p-2 mt-3"
                      type="tel"
                      name="phoneNumber"
                      id="phone"
                      placeholder="Contact No.(Optional)"
                    />
                  </div>
                  <div className="row mb-3">
                    <input
                      className="col-12 border rounded-3 p-2"
                      type="email"
                      name="_replyto"
                      id="email-address"
                      placeholder="Email"
                      required
                    />
                  </div>
                  <div className="row mb-3">
                    <textarea
                      className="col-12 border rounded-3 p-2"
                      rows="3"
                      name="message"
                      id="message"
                      placeholder="Enter your message"
                      required
                    ></textarea>
                  </div>
                </div>
                <button
                  className="btn"
                  style={{ backgroundColor: "#47b2e4", width: "7rem" }}
                  type="submit"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="container footer-bottom clearfix">
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>SixthSensAI 2024 (reg as Aabhas Gurukuls LLP)</span>
            </strong>
            . All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
